module.exports = __webpack_public_path__ + "static/media/picture-(63).0620691b.JPG";